export default __webpack_public_path__ + "static/media/welcome_page.5fc9dd75.svg";